import { Component, OnInit, Input } from '@angular/core';
import { ProductService } from '../../../services/product.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import * as moment from 'moment';

@Component({
  selector: 'app-products-cost-income',
  templateUrl: './products-cost-income.component.html',
  styleUrls: ['./products-cost-income.component.scss']
})
export class ProductsIncomeComponent implements OnInit {

  @Input() id;
  Data;
  totalIncome:number = 0;
  totalCost:number = 0;
  result:number = 0;
  successIncome:boolean = false;
  successCost:boolean = false;

  constructor(private ProductService: ProductService,
              private route: ActivatedRoute,
              private toastr: ToastsManager,
              private commonHelper:CommonHelper) {}

  async ngOnInit() {
    await this.loadProducts();
  }

  async loadProducts(){
    //this.Data = await this.productService.getCostAndIncomes(this.route.snapshot.params['id']);
    this.successCost = this.Data.successCost;
    this.successIncome = this.Data.successIncome;
    this.totalCost = this.Data.project.totalCost;
    this.totalIncome = this.Data.project.totalIncome;
    this.result = (this.totalIncome/this.totalCost)-1;
  }

  checkLetterStatus(status:number){
    return status == 5? true:false;
  }

  checkApprovalStatus(status:number){
    return status == 3? true:false;
  }

  getCompetence(date){
    let month = moment(date).month();
    return this.commonHelper.formatMonth(month);
  }

  getYear(date){
    return moment(date).year();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/products/products-cost-income/products-cost-income.component.ts